"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pandeSearchReducer = exports.pandeSearchActions = exports.WANT_TO_CHECK = exports.TYPES = exports.SITE_SELECT_CODE = exports.LOADING_STATUS = exports.CONTENTS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'pandeSearch';

// アクションタイプ
const TYPES = exports.TYPES = {
  // 確認したい情報変更
  CHANGE_WANTTO_CHECK: PREFIX + 'ChangeWanttoCheck',
  // 検索条件変更
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  // 検索結果設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // ページ変更
  CHANGE_CURRENT_PAGE: PREFIX + 'ChangeCurrentPage',
  // １ページの表示件数変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // スクロール位置保存
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop',
  // ページリセット
  RESET_PAGING: PREFIX + 'ResetPaging',
  // 全て表示切り替え
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  // 会社／組織選択変更
  CHANGE_KAISHA_SOSHIKI: PREFIX + 'ChangeKaishaSoshiki',
  // 勤務場所選択変更
  CHANGE_WORK_PLACE: PREFIX + 'ChangeWorkPlace',
  // 機能間共有項目の設定
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion',
  // 更新画面遷移
  GO_UPDATE: PREFIX + 'GoUpdate',
  // 詳細画面遷移
  GO_DETAIL: PREFIX + 'GoDetail',
  // 検索画面遷移
  GO_MAIN: PREFIX + 'GoMain',
  // 感染症検索報告情報取得設定
  SET_ENTRIES: PREFIX + 'SetEntries',
  // 更新画面項目設定
  SET_ENTRY: PREFIX + 'SetEntry',
  // 更新画面会社／組織選択変更
  CHANGE_UPD_KAISHA_SOSHIKI: PREFIX + 'ChangeUpdKaishaSoshiki',
  // 確認中項目変更
  CHANGE_CHECKING_FLG: PREFIX + 'ChangeCheckingFlg',
  // 確認中項目変更
  CHANGE_CHECKING_FLG_ONLY: PREFIX + 'ChangeCheckingFlgOnly',
  // 削除完了
  DELETE_COMP: PREFIX + 'DeleteComp',
  // 更新完了
  UPDATE_COMP: PREFIX + 'UpdateComp',
  // 一覧追加
  APPEND_RECORD: PREFIX + 'AppendRecord',
  // 一覧編集
  MODIFY_RECORD: PREFIX + 'ModifyRecord',
  // 一覧削除
  DELETE_RECORD: PREFIX + 'DeleteRecord',
  // 初期状態にする
  CLEAR: PREFIX + 'Clear'
};

// コンテンツ
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  UPDATE: 'update',
  DETAIL: 'detail'
};

// 確認したい情報
const WANT_TO_CHECK = exports.WANT_TO_CHECK = {
  REPORT: 'report',
  PROGRESS: 'progress',
  SHODOKU: 'shodoku'
};

// 拠点選択コード（拠点選択／拠点入力）
const SITE_SELECT_CODE = exports.SITE_SELECT_CODE = {
  SELECT: '1',
  INPUT: '2'
};

// 読み込みステータス
const LOADING_STATUS = exports.LOADING_STATUS = {
  NOW_LOADING: '0',
  DATA_COMPLETED: '1',
  NO_DATA: '2'
};

// 初期状態
const INIT_STATE = {
  dispContent: CONTENTS.MAIN,
  wanttoCheck: WANT_TO_CHECK.REPORT,
  updateYohi: _CodeConsts.CODE.PANDE_YOHI.CODE_0,
  // 管理表
  [WANT_TO_CHECK.REPORT]: {
    doSearch: false,
    searchConditions: {
      reportNo: '',
      includeRelReportNo: false,
      kaishaCd: '',
      soshikiCd: '',
      label: '',
      workPlaceEntry: {},
      attributeCd: [],
      reportEndFlg: _CodeConsts.CODE.PANDE_REPORT_END_FLG.CODE_0,
      reportStatusCd: [],
      kensaRstCd: [],
      closecontactCd: '',
      shojoCd: '',
      shusshaCd: '',
      firstReportDtStart: '',
      firstReportDtEnd: '',
      hasshoDtStart: '',
      hasshoDtEnd: '',
      kensaDtStart: '',
      kensaDtEnd: '',
      kensaRstDtStart: '',
      kensaRstDtEnd: '',
      treatmentsEndDtStart: '',
      treatmentsEndDtEnd: '',
      seriousFlg: ''
    },
    searchResultList: [],
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    },
    paging: {
      viewNum: 50,
      currentPage: 0
    },
    showAll: false
  },
  // 報告遅延アラート
  [WANT_TO_CHECK.PROGRESS]: {
    doSearch: false,
    searchConditions: {
      reportNo: '',
      kaishaCd: '',
      soshikiCd: '',
      label: '',
      reportEndFlg: _CodeConsts.CODE.PANDE_REPORT_END_FLG.CODE_0,
      reportStatusCd: [],
      kensaRstCd: [],
      checkingFlgs: _CodeConsts.CODE.PANDE_EXISTENCE.CODE_1,
      customerReportFlg: '',
      firstReportDtStart: '',
      firstReportDtEnd: '',
      lastReportDtStart: '',
      lastReportDtEnd: '',
      seriousFlg: ''
    },
    searchResultList: [],
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    },
    paging: {
      viewNum: 50,
      currentPage: 0
    },
    showAll: false
  },
  // 消毒
  [WANT_TO_CHECK.SHODOKU]: {
    doSearch: false,
    searchConditions: {
      reportNo: '',
      kaishaCd: '',
      soshikiCd: '',
      label: '',
      workPlaceEntry: {},
      reportEndFlg: _CodeConsts.CODE.PANDE_REPORT_END_FLG.CODE_0,
      reportStatusCd: [],
      kensaRstCd: [],
      hasshoDtStart: '',
      hasshoDtEnd: '',
      shusshaCd: _CodeConsts.CODE.PANDE_EXISTENCE.CODE_1,
      seriousFlg: ''
    },
    searchResultList: [],
    scrollTop: {
      index: 0,
      scrollY: 0,
      noSticky: false
    },
    paging: {
      viewNum: 50,
      currentPage: 0
    },
    showAll: false
  },
  // 詳細・更新対象
  reportNo: '',
  loadingStatus: LOADING_STATUS.NOW_LOADING,
  entries: {
    initReportNo: false,
    initKaishaSoshiki: false,
    initKensaRstCd: false,
    initClosecontactCd: false
  },
  fromDetail: false
};
const pandeSearchActions = exports.pandeSearchActions = (0, _reduxActions.createActions)({
  [TYPES.CHANGE_WANTTO_CHECK]: function () {
    return {
      value: arguments.length <= 0 ? undefined : arguments[0],
      shareCondition: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      key: arguments.length <= 1 ? undefined : arguments[1],
      value: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      searchResultList: arguments.length <= 1 ? undefined : arguments[1],
      updateYohi: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      currentPage: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_CURRENT_PAGE]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      currentPage: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      viewNum: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      scrollTop: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.RESET_PAGING]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      showAll: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_KAISHA_SOSHIKI]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      kaishaCd: arguments.length <= 1 ? undefined : arguments[1],
      soshikiCd: arguments.length <= 2 ? undefined : arguments[2],
      label: arguments.length <= 3 ? undefined : arguments[3]
    };
  },
  [TYPES.CHANGE_WORK_PLACE]: function () {
    return {
      pms: arguments.length <= 0 ? undefined : arguments[0],
      workPlaceEntry: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      shareCondition: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_UPDATE]: function () {
    return {
      reportNo: arguments.length <= 0 ? undefined : arguments[0],
      fromDetail: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.GO_DETAIL]: function () {
    return {
      reportNo: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_MAIN]: function () {
    return {};
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      loadingStatus: arguments.length <= 0 ? undefined : arguments[0],
      data: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_UPD_KAISHA_SOSHIKI]: function () {
    return {
      kaishaSoshiki: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CHECKING_FLG]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_CHECKING_FLG_ONLY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.DELETE_COMP]: function () {
    return {};
  },
  [TYPES.UPDATE_COMP]: function () {
    return {};
  },
  [TYPES.APPEND_RECORD]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      record: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.MODIFY_RECORD]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      record: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.DELETE_RECORD]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      record: arguments.length <= 1 ? undefined : arguments[1]
    };
  }
}, TYPES.CLEAR);
const pandeSearchReducer = exports.pandeSearchReducer = (0, _reduxActions.handleActions)({
  [TYPES.CHANGE_WANTTO_CHECK]: (state, action) => {
    const {
      reportNo,
      kaishaCd,
      soshikiCd,
      kaishaSoshikiLabel,
      workPlaceEntry,
      reportEndFlg,
      reportStatusCd,
      kensaRstCd,
      firstReportDtStart,
      firstReportDtEnd,
      kensaRstDtStart,
      kensaRstDtEnd
    } = action.payload.shareCondition;
    return _objectSpread(_objectSpread({}, state), {}, {
      wanttoCheck: action.payload.value,
      [WANT_TO_CHECK.REPORT]: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.REPORT]), {}, {
        searchResultList: [],
        searchConditions: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.REPORT].searchConditions), {}, {
          reportNo: reportNo,
          kaishaCd: kaishaCd,
          soshikiCd: soshikiCd,
          label: kaishaSoshikiLabel,
          workPlaceEntry: workPlaceEntry,
          reportEndFlg: reportEndFlg,
          reportStatusCd: reportStatusCd,
          kensaRstCd: kensaRstCd,
          firstReportDtStart: firstReportDtStart,
          firstReportDtEnd: firstReportDtEnd,
          kensaRstDtStart: kensaRstDtStart,
          kensaRstDtEnd: kensaRstDtEnd
        })
      }),
      [WANT_TO_CHECK.PROGRESS]: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.PROGRESS]), {}, {
        searchResultList: [],
        searchConditions: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.PROGRESS].searchConditions), {}, {
          reportNo: reportNo,
          kaishaCd: kaishaCd,
          soshikiCd: soshikiCd,
          label: kaishaSoshikiLabel,
          reportEndFlg: reportEndFlg,
          reportStatusCd: reportStatusCd,
          kensaRstCd: kensaRstCd,
          firstReportDtStart: firstReportDtStart,
          firstReportDtEnd: firstReportDtEnd
        })
      }),
      [WANT_TO_CHECK.SHODOKU]: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.SHODOKU]), {}, {
        searchResultList: [],
        searchConditions: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.SHODOKU].searchConditions), {}, {
          reportNo: reportNo,
          kaishaCd: kaishaCd,
          soshikiCd: soshikiCd,
          label: kaishaSoshikiLabel,
          workPlaceEntry: workPlaceEntry,
          reportEndFlg: reportEndFlg,
          reportStatusCd: reportStatusCd,
          kensaRstCd: kensaRstCd
        })
      })
    });
  },
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state[action.payload.pms].searchConditions), {}, {
        [action.payload.key]: action.payload.value
      })
    })
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    updateYohi: action.payload.updateYohi,
    [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
      searchResultList: action.payload.searchResultList,
      doSearch: false
    })
  }),
  [TYPES.CHANGE_CURRENT_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
      paging: _objectSpread(_objectSpread({}, state[action.payload.pms].paging), {}, {
        currentPage: action.payload.currentPage
      })
    })
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
      paging: _objectSpread(_objectSpread({}, state[action.payload.pms].paging), {}, {
        currentPage: 0,
        viewNum: action.payload.viewNum
      })
    })
  }),
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
      scrollTop: action.payload.scrollTop
    })
  }),
  [TYPES.RESET_PAGING]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
      paging: _objectSpread({}, INIT_STATE[action.payload.pms].paging)
    })
  }),
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    const newSearchResultList = JSON.parse(JSON.stringify(state[action.payload.pms].searchResultList)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
        searchResultList: newSearchResultList,
        showAll: action.payload.showAll
      })
    });
  },
  [TYPES.CHANGE_KAISHA_SOSHIKI]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state[action.payload.pms].searchConditions), {}, {
        kaishaCd: action.payload.kaishaCd,
        soshikiCd: action.payload.soshikiCd,
        label: action.payload.label
      })
    })
  }),
  [TYPES.CHANGE_WORK_PLACE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    [action.payload.pms]: _objectSpread(_objectSpread({}, state[action.payload.pms]), {}, {
      searchConditions: _objectSpread(_objectSpread({}, state[action.payload.pms].searchConditions), {}, {
        workPlaceEntry: action.payload.workPlaceEntry
      })
    })
  }),
  [TYPES.APPLY_SHARE_CONDITION]: (state, action) => {
    const {
      reportNo,
      kaishaCd,
      soshikiCd,
      kaishaSoshikiLabel,
      workPlaceEntry,
      reportEndFlg,
      reportStatusCd,
      kensaRstCd,
      firstReportDtStart,
      firstReportDtEnd,
      kensaRstDtStart,
      kensaRstDtEnd
    } = action.payload.shareCondition;
    return _objectSpread(_objectSpread({}, state), {}, {
      [WANT_TO_CHECK.REPORT]: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.REPORT]), {}, {
        searchConditions: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.REPORT].searchConditions), {}, {
          reportNo: reportNo,
          kaishaCd: kaishaCd,
          soshikiCd: soshikiCd,
          label: kaishaSoshikiLabel,
          workPlaceEntry: workPlaceEntry,
          reportEndFlg: reportEndFlg,
          reportStatusCd: reportStatusCd,
          kensaRstCd: kensaRstCd,
          firstReportDtStart: firstReportDtStart,
          firstReportDtEnd: firstReportDtEnd,
          kensaRstDtStart: kensaRstDtStart,
          kensaRstDtEnd: kensaRstDtEnd
        })
      }),
      [WANT_TO_CHECK.PROGRESS]: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.PROGRESS]), {}, {
        searchConditions: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.PROGRESS].searchConditions), {}, {
          reportNo: reportNo,
          kaishaCd: kaishaCd,
          soshikiCd: soshikiCd,
          label: kaishaSoshikiLabel,
          reportEndFlg: reportEndFlg,
          reportStatusCd: reportStatusCd,
          kensaRstCd: kensaRstCd,
          firstReportDtStart: firstReportDtStart,
          firstReportDtEnd: firstReportDtEnd
        })
      }),
      [WANT_TO_CHECK.SHODOKU]: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.SHODOKU]), {}, {
        searchConditions: _objectSpread(_objectSpread({}, state[WANT_TO_CHECK.SHODOKU].searchConditions), {}, {
          reportNo: reportNo,
          kaishaCd: kaishaCd,
          soshikiCd: soshikiCd,
          label: kaishaSoshikiLabel,
          workPlaceEntry: workPlaceEntry,
          reportEndFlg: reportEndFlg,
          reportStatusCd: reportStatusCd,
          kensaRstCd: kensaRstCd
        })
      })
    });
  },
  [TYPES.GO_UPDATE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.UPDATE,
    reportNo: action.payload.reportNo,
    loadingStatus: LOADING_STATUS.NOW_LOADING,
    fromDetail: action.payload.fromDetail,
    entries: {
      initReportNo: false,
      initKaishaSoshiki: false
    }
  }),
  [TYPES.GO_DETAIL]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.DETAIL,
    reportNo: action.payload.reportNo,
    loadingStatus: LOADING_STATUS.NOW_LOADING,
    entries: {}
  }),
  [TYPES.GO_MAIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.MAIN,
    reportNo: '',
    loadingStatus: LOADING_STATUS.NOW_LOADING,
    entries: {},
    [state.wanttoCheck]: _objectSpread(_objectSpread({}, state[state.wanttoCheck]), {}, {
      doSearch: action.payload.doSearch
    })
  }),
  [TYPES.SET_ENTRIES]: (state, action) => {
    let reportStatusCd = action.payload.data.reportStatusCd;
    let ENTRIES = {
      entries: _objectSpread(_objectSpread({}, action.payload.data), {}, {
        initReportNo: true,
        initKaishaSoshiki: true
      })
    };
    if (reportStatusCd === _CodeConsts.CODE.PANDE_REPORT_STATUS.CODE_5) {
      ENTRIES['entries']['initClosecontactCd'] = true;
    } else if (reportStatusCd === _CodeConsts.CODE.PANDE_REPORT_STATUS.CODE_3 || reportStatusCd === _CodeConsts.CODE.PANDE_REPORT_STATUS.CODE_4) {
      ENTRIES['entries']['initKensaRstCd'] = true;
    }
    return _objectSpread(_objectSpread({}, state), {}, {
      loadingStatus: action.payload.loadingStatus
    }, ENTRIES);
  },
  [TYPES.SET_ENTRY]: (state, action) => {
    let ENTRIES = {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      })
    };
    // 報告対象者の状態が療養終了の場合は、確認中フラグは空にする
    if (action.payload.key === 'reportStatusCd' && action.payload.value === _CodeConsts.CODE.PANDE_REPORT_STATUS.CODE_4) {
      const kensaDt = ENTRIES.entries.checkingFlgs.kensaDt;
      const kensaRstDt = ENTRIES.entries.checkingFlgs.kensaRstDt;
      const treatmentsPolicyCd = ENTRIES.entries.checkingFlgs.treatmentsPolicyCd;
      const treatmentsEndDt = ENTRIES.entries.checkingFlgs.treatmentsEndDt;
      ENTRIES['entries']['checkingFlgs'] = {};
      if (kensaDt) {
        ENTRIES.entries.checkingFlgs.kensaDt = kensaDt;
      }
      if (kensaRstDt) {
        ENTRIES.entries.checkingFlgs.kensaRstDt = kensaRstDt;
      }
      if (treatmentsPolicyCd) {
        ENTRIES.entries.checkingFlgs.treatmentsPolicyCd = treatmentsPolicyCd;
      }
      if (treatmentsEndDt) {
        ENTRIES.entries.checkingFlgs.treatmentsEndDt = treatmentsEndDt;
      }
    }
    // 確認中フラグを持つ項目の場合は、確認中フラグをOFFにする
    Object.keys(state.entries.checkingFlgs).forEach(key => {
      if (key === action.payload.key) {
        ENTRIES['entries']['checkingFlgs'] = _objectSpread(_objectSpread({}, state.entries.checkingFlgs), {}, {
          [action.payload.key]: false
        });
      }
    });
    return _objectSpread(_objectSpread({}, state), ENTRIES);
  },
  [TYPES.CHANGE_UPD_KAISHA_SOSHIKI]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        kaishaCd: action.payload.kaishaSoshiki.kaishaCd,
        soshikiCd: action.payload.kaishaSoshiki.soshikiCd,
        label: action.payload.kaishaSoshiki.label
      })
    });
  },
  [TYPES.CHANGE_CHECKING_FLG]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    entries: _objectSpread(_objectSpread({}, state.entries), {}, {
      [action.payload.key]: _stringConsts.STRING_CONSTS.EMPTY,
      checkingFlgs: _objectSpread(_objectSpread({}, state.entries.checkingFlgs), {}, {
        [action.payload.key]: action.payload.value
      })
    })
  }),
  [TYPES.CHANGE_CHECKING_FLG_ONLY]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    entries: _objectSpread(_objectSpread({}, state.entries), {}, {
      checkingFlgs: _objectSpread(_objectSpread({}, state.entries.checkingFlgs), {}, {
        [action.payload.key]: action.payload.value
      })
    })
  }),
  [TYPES.DELETE_COMP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.MAIN,
    loadingStatus: LOADING_STATUS.NOW_LOADING,
    reportNo: '',
    entries: {},
    [state.wanttoCheck]: _objectSpread(_objectSpread({}, state[state.wanttoCheck]), {}, {
      doSearch: true
    })
  }),
  [TYPES.UPDATE_COMP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.MAIN,
    loadingStatus: LOADING_STATUS.NOW_LOADING,
    reportNo: '',
    entries: {},
    [state.wanttoCheck]: _objectSpread(_objectSpread({}, state[state.wanttoCheck]), {}, {
      doSearch: true
    })
  }),
  [TYPES.APPEND_RECORD]: (state, action) => {
    const records = [...state.entries[action.payload.key]];
    records.push(action.payload.record);
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: records
      })
    });
  },
  [TYPES.MODIFY_RECORD]: (state, action) => {
    let records = state.entries[action.payload.key].slice();
    const idx = records.findIndex(r => r.key === action.payload.record.key);
    records.splice(idx, 1, _objectSpread({}, action.payload.record));
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: records
      })
    });
  },
  [TYPES.DELETE_RECORD]: (state, action) => {
    let records = state.entries[action.payload.key].slice();
    const idx = records.findIndex(r => r.key === action.payload.record.key);
    records.splice(idx, 1);
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: records
      })
    });
  },
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);